import { render } from "./NewUserGrowth.vue?vue&type=template&id=91a4806e&scoped=true"
import script from "./NewUserGrowth.vue?vue&type=script&lang=js"
export * from "./NewUserGrowth.vue?vue&type=script&lang=js"

import "./NewUserGrowth.vue?vue&type=style&index=0&id=91a4806e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a4806e"]])

export default __exports__